import Vue from "vue";
import VueRouter from "vue-router";
// import { isMobile } from "../assets/javascript/common";
Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// pc端路由
export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import("../views/web/page/homePage/homePage.vue"),
    title: '首页'
  }, {
    path: '/Course',
    name: 'course',
    component: () => import("../views/web/page/coursePage/coursePage.vue"),
    title: '常见问题'
  }
]
// 手机端路由
export const routesMobile = [{
  path: '/',
  name: 'home',
  component: () => import('../views/mobile/index.vue'),
  title: '首页'
}, {
  path: '/course',
  name: 'course',
  component: () => import('../views/mobile/course/course.vue'),
  title: '常见问题'
}, {
  path: "/NewsDetail",
  name: "NewsDetail",
  component: () => import("../views/mobile/newsDetail/newsDetail.vue"),
  // meta: {
  //   // show: false,
  //   name: "活动&资讯",
  // },
}]

// export const getMobileRoutes = () => {
//   const routes = [routesMobile[1]];
//   const other = routesMobile[0].children.filter((v) => v.meta.show);
//   return [...routes, ...other];
// };

const router = new VueRouter({
  routes: /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? routesMobile : routes,
  // mode: process.env.NODE_ENV === "dev" ? "hash" : "history",
  mode: "history",
  // 跳转时页面从顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js